"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxPriceFilter = void 0;
/**
 * It allows you to filter products in the recommendation frame for products cheaper than the given maximum price
 */
var MaxPriceFilter = /** @class */ (function () {
    /** @param maxPrice Minimal product price to filter */
    function MaxPriceFilter(maxPrice) {
        this.enableMultiple = false;
        this.urlParam = 'filterpricemax';
        this.value = maxPrice;
    }
    return MaxPriceFilter;
}());
exports.MaxPriceFilter = MaxPriceFilter;
//# sourceMappingURL=MaxPriceFilter.js.map